// extracted by mini-css-extract-plugin
export var container = "HeroText-module--container--10Rnr";
export var title = "HeroText-module--title--1Ur6g";
export var description = "HeroText-module--description--t9GmQ";